import { LifecycleManager } from './lifecycle/lifecycle'
import { SDKConfig, SDKInstance } from './lifecycle/lifecycle.types'
import { ModalSDK } from './modal/modal.types'
import { captureBaseUri, shouldSkipAutoInit } from './util/script-params'
import { AnalyticsEventData } from './analytics/AnalyticsManager'

import '@classy/embedded-components/dist/common.css'

/**
 * Extended EG API interface with lifecycle methods for SPA support
 */
export interface EGAPI {
  // Existing API (populated by init)
  modal?: ModalSDK
  sendAnalyticsEvent?: (eventName: string, eventData: AnalyticsEventData) => void
  // Lifecycle API for SPA support
  init: (config?: SDKConfig) => Promise<SDKInstance>
  destroy: () => void
  isInitialized: () => boolean
}

// Capture the script URL params at load time (document.currentScript is only available during initial execution)
if (typeof window !== 'undefined') {
  captureBaseUri()
}

const skipAutoInit = typeof window !== 'undefined' ? shouldSkipAutoInit() : false

if (typeof window !== 'undefined') {
  // Initialize window.eg with lifecycle API
  window.eg = {
    init: (config?: SDKConfig) => LifecycleManager.init(config),
    destroy: () => LifecycleManager.destroy(),
    isInitialized: () => LifecycleManager.isInitialized(),
  }

  // Auto-init via LifecycleManager unless manual init is requested via
  // ?manualInit=true.  This eliminates the old legacyInit() duplication —
  // all initialization now goes through LifecycleManager.init().
  if (!skipAutoInit) {
    const boot = () => LifecycleManager.init({ win: window })

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true })
    } else {
      boot()
    }
  }
}

export { LifecycleManager }
